(() => {
  'use strict';
  if(customElements.get('csb-steel-paper-scenes'))return;
  const clamp=x=>Math.max(0,Math.min(1,x)),phase=(t,a,b)=>clamp((t-a)/(b-a)),ease=x=>x*x*(3-2*x);
  class CsbSteelPaperScenes extends HTMLElement {
    connectedCallback(){this.parts={};this.querySelectorAll('[data-paper-caption]').forEach((n,i)=>(this.captions??=[])[i]=n);this.setTime(0);}
    node(name){return this.parts[name]??=this.querySelector(`[data-paper-${name}]`);}
    attr(name,key,value){this.node(name)?.setAttribute(key,String(value));}
    setTime(milliseconds){
      if(!this.parts)return;
      const durations=[4000,6500,4700,4500],total=19700;
      let t=((milliseconds%total)+total)%total,index=0;
      while(t>=durations[index])t-=durations[index++];
      this.dataset.scenario=['coffee','fire','wind','bin'][index];
      this.captions?.forEach((node,i)=>{if(i===index)node.setAttribute('aria-current','step');else node.removeAttribute('aria-current');});
      // A short dissolve separates the accidents; the cup tips after just 150 ms.
      this.attr('world','opacity',Math.min(1,(t+120)/300,(durations[index]-t)/300));
      for(const [name,scene] of [['coffee',0],['fire',1],['window',2],['wind',2],['bin-back',3],['bin-front',3]])this.attr(name,'opacity',index===scene?1:0);
      this.attr('sheet','transform','rotate(-5 302 352)');this.attr('sheet','opacity',1);this.attr('crumpled','opacity',0);this.attr('folds','opacity',0);
      this.attr('stain','opacity',0);for(const name of ['hole','char']){this.attr(name,'rx',0);this.attr(name,'ry',0);}
      if(index===0){
        const tip=ease(phase(t,150,850)),spill=ease(phase(t,400,2100)),pour=phase(t,350,650)*(1-phase(t,2100,2700));
        this.attr('cup','transform',`translate(${-18*tip} ${30*tip}) rotate(${-65*tip} 568 210)`);
        const a=-65*tip*Math.PI/180,x=568-18*tip-60*Math.cos(a)+46*Math.sin(a),y=210+30*tip-60*Math.sin(a)-46*Math.cos(a);
        const d=`M${x} ${y}Q${x-18} ${y+40} 445 330`;
        for(const name of ['pour','pour-shine']){this.attr(name,'d',d);this.attr(name,'opacity',pour);}
        this.attr('pool','transform',`translate(445 330) scale(${spill*1.65} ${spill*1.28})`);
        this.attr('stain','opacity',spill);this.attr('splash','opacity',pour);
        this.attr('splash','transform',`translate(0 ${-8*Math.sin(t/85)*pour})`);
      }else if(index===1){
        // A glowing ember detaches from the upright candle, drifts, then lands on the paper.
        const drift=ease(phase(t,450,1600));
        const angle=-5*Math.PI/180,landingX=302+128*Math.cos(angle)+198*Math.sin(-angle),landingY=352+128*Math.sin(angle)+198*Math.cos(angle);
        this.attr('ember','transform',`translate(${530+(landingX-530)*drift} ${497+(landingY-497)*drift-85*Math.sin(Math.PI*drift)}) rotate(${drift*210})`);
        this.attr('ember','opacity',phase(t,350,500)*(1-phase(t,1850,2350)));
        const burn=ease(phase(t,1600,5350));
        this.attr('char','rx',burn*610);this.attr('char','ry',burn*690);
        this.attr('hole','rx',Math.max(0,burn*610-23));this.attr('hole','ry',Math.max(0,burn*690-25));
        this.attr('ash','opacity',phase(t,3000,5400));
        this.attr('flames','transform','rotate(-5 302 352)');
        this.node('flames').querySelectorAll('[data-paper-flame]').forEach((node,i)=>{
          const x=480-i*56,rx=Math.max(1,burn*610-12),ry=Math.max(1,burn*690-12);
          const edge=Math.abs(x-430)/rx;
          const y=550-ry*Math.sqrt(Math.max(0,1-edge*edge));
          node.setAttribute('transform',`translate(${x} ${y}) scale(${(.48+burn*.4)*(1+.12*Math.sin(t/80+i*2))} ${.7+.22*Math.sin(t/105+i)})`);
          node.setAttribute('opacity',String((edge<1&&y>112&&y<592?1:0)*phase(t,1650+i*120,1950+i*120)*(1-phase(t,5150,5800))));
        });
      }else if(index===2){
        const flight=ease(phase(t,550,3700));
        this.attr('sheet','transform',`translate(${-flight*900} ${-flight*470+Math.sin(flight*10)*38}) rotate(${-5-flight*120} 302 352)`);
        this.attr('wind','transform',`translate(${-((t%1200)/1200)*220} ${Math.sin(t/240)*4})`);
        this.attr('wind','opacity',Math.sin((t%1200)/1200*Math.PI)*.8);
      }else{
        // Compress the sheet into a creased ball before throwing it. The opaque front wall
        // occludes the ball only after it passes through the opening; no fade through the bin.
        const crumple=ease(phase(t,250,1450)),fold=phase(t,1250,1450);
        const throwIn=ease(phase(t,1550,2800)),drop=ease(phase(t,2800,3500));
        this.attr('sheet','transform',`translate(302 352) rotate(${-5+crumple*22}) scale(${1-.81*crumple} ${1-.86*crumple}) skewX(${Math.sin(crumple*Math.PI)*14}) translate(-302 -352)`);
        this.attr('sheet','opacity',1-fold);this.attr('folds','opacity',crumple*.9);
        this.attr('crumpled','opacity',fold);
        this.attr('crumpled','transform',`translate(${302+throwIn*279} ${352+throwIn*33-150*Math.sin(throwIn*Math.PI)+drop*150}) rotate(${crumple*17+throwIn*343}) scale(${.85+.15*crumple})`);

      }
    }
  }
  customElements.define('csb-steel-paper-scenes',CsbSteelPaperScenes);
})();
